import * as React from "react";
import Input from "./Input";

interface Props {
  value: string;
  name: string;
  innerRef?: React.Ref<any>;
  skipFirstInput: boolean;
  validate: boolean;
}

class EmailInput extends React.Component<Props> {
  render() {
    return (
      <Input
        value={this.props.value}
        placeholder="Epostadress"
        required={this.props.validate ?? true}
        validations={this.props.validate ?? true ? "isEmail" : undefined}
        type="email"
        name={this.props.name}
        validationError="Prova igen, skriv in en epostadress"
        skipFirstInput={this.props.skipFirstInput}
        ref={this.props.innerRef}
      />
    );
  }
}

export default React.forwardRef((props: Props, ref) => (
  <EmailInput innerRef={ref} {...props} />
));
